import { useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Grid, Stack, Typography } from "@mui/material"
import TuneIcon from '@mui/icons-material/Tune';
// import HelpIcon from '@mui/icons-material/Help';
import CloseIcon from '@mui/icons-material/Close';
import BaseButton from "../BaseButton"
import BaseCheckbox from "../BaseCheckbox";

import { setNutritionFilterOptions } from "../../store";

const NutritionFilterForm = ({ sx, onClose, label, type, categories = [] }) => {
  const dispatch = useDispatch()
  const resFilterOptions = useSelector(state => state.nutritionFilterOptions)

  const [filterOptions, setFilterOptions] = useState()
  const [guidanceLevels, setGuidanceLevels] = useState([])
  const [categoryList, setCategoryList] = useState([])

  useMemo(() => {
    setFilterOptions(resFilterOptions)
    if (resFilterOptions) {
      if (resFilterOptions?.guidanceLevels) setGuidanceLevels(resFilterOptions?.guidanceLevels)
    }
  }, [resFilterOptions])

  const handleChangeCategory = (category) => {
    const temp = [...categoryList]
    const index = temp.indexOf(category);
    
    if (index > -1) { // only splice array when item is found
      temp.splice(index, 1); // 2nd parameter means remove one item only
      setCategoryList(temp)
    } else {
      setCategoryList([...temp, category])
    }
  }

  const handleChangeGuidanceLevel = (name) => {
    const temp = [...guidanceLevels]
    const index = temp.indexOf(name);
    
    if (index > -1) { // only splice array when item is found
      temp.splice(index, 1); // 2nd parameter means remove one item only
      setGuidanceLevels(temp)
    } else {
      setGuidanceLevels([...temp, name])
    }
  }

  const handleClickFilter = () => {
    const options = {
      ...filterOptions,
      guidanceLevels,
      category: categoryList
    }
    dispatch(setNutritionFilterOptions(options))
    onClose()
  }

  const handleResetFilter = () => {
    dispatch(setNutritionFilterOptions({
      category: [],
      guidanceLevels: [],
    }))
    onClose()
  }

  return (
    <Box
      sx={{
        width: '100%',
        minWidth: type === 'guidance' ? '390px' : '350px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        ...sx
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          bgcolor: 'background.default',
          padding: '16px 20px',
          borderRadius: '16px 16px 0 0'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <TuneIcon
            sx={{
              fontSize: '20px',
              color: 'primary.mainBlue'
            }}
          />
          <Typography
            variant="h4"
            color="primary.black"
            sx={{
              ml: '4px'
            }}
          >
            Choose {label}
          </Typography>
        </Box>
        <CloseIcon
          sx={{
            fontSize: '24px',
            color: 'primary.mediumGray',
            cursor: 'pointer'
          }}
          onClick={onClose}
        />
      </Box>
      <Box
        sx={{
          padding: '24px 16px',
          width: '100%'
        }}
      >
        {type !== 'category' ? (
          <Grid container columnSpacing={'10px'}>
            {categories.map((item => (
              <Grid item xs={6} key={item}>
                <BaseCheckbox
                  label={item}
                  checked={categoryList.includes(item)}
                  onChange={() => handleChangeCategory(item)}
                />
              </Grid>
            )))}
          </Grid>
        ) : (
          <Stack direction={{ xs: 'row', md: 'row'}} spacing={{ xs: '4px', md: '12px' }}>
            <BaseCheckbox
              label='Low'
              checked={guidanceLevels.includes('low')}
              onChange={() => handleChangeGuidanceLevel('low')}
            />
            <BaseCheckbox
              label='Moderate'
              checked={guidanceLevels.includes('moderate')}
              onChange={() => handleChangeGuidanceLevel('moderate')}
            />
            <BaseCheckbox
              label='High'
              checked={guidanceLevels.includes('high')}
              onChange={() => handleChangeGuidanceLevel('high')}
            />
          </Stack>
        )}
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '16px 20px'
        }}
      >
        <Box
          sx={{
            cursor: 'pointer'
          }}
          onClick={handleResetFilter}
        >
          <Typography variant="body">
            Reset
          </Typography>
        </Box>
        <BaseButton
          buttonType='primary'
          width='auto'
          onClick={handleClickFilter}
        >
          <Typography
            variant="body"
            color="white"
          >
            Apply
          </Typography>
        </BaseButton>
      </Box>
    </Box>
  )
}

export default NutritionFilterForm